import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Grid } from 'antd';
import { ArrowRightOutlined, ShoppingOutlined } from '@ant-design/icons';
import { useActiveCart } from '@core/hooks/useCart';
import Button from '@components/base/Button';
import Price from '@components/base/Price';
import { useIndustry } from '@/app/providers/industry-context.js';
import { useCopy } from '@/app/providers/useCopy';

export default function MobileCartBarDefault() {
  const { key: industryKey } = useIndustry();
  const t = useCopy();
  const screens = Grid.useBreakpoint();
  const hasResolvedBreakpoint = Object.keys(screens).length > 0;
  const isMobile = hasResolvedBreakpoint && !screens.sm;
  const { cart, lineCount } = useActiveCart();
  const { pathname } = useLocation();

  const isVisible =
    isMobile &&
    lineCount > 0 &&
    pathname !== '/cart' &&
    pathname !== '/checkout' &&
    pathname !== '/orders' &&
    pathname !== '/account';
  const isRestaurant = industryKey === 'restaurant';

  useEffect(() => {
    if (isRestaurant) {
      document.documentElement.classList.toggle('restaurant-mobile-cart-bar-active', isVisible);
    } else {
      document.documentElement.classList.toggle('default-mobile-cart-bar-active', isVisible);
    }
    return () => {
      document.documentElement.classList.remove('restaurant-mobile-cart-bar-active');
      document.documentElement.classList.remove('default-mobile-cart-bar-active');
    };
  }, [isVisible, isRestaurant]);

  if (!isVisible) {
    return null;
  }

  if (isRestaurant) {
    return (
      <div
        className="restaurant-mobile-cart-bar"
        style={{
          position: 'fixed',
          zIndex: 3001,
          boxSizing: 'border-box',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 8,
          overflow: 'hidden',
          padding: '0.625rem 0.75rem',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            minWidth: 0,
            flex: '1 1 auto',
            color: '#ffffff',
          }}
        >
          <ShoppingOutlined style={{ fontSize: 18, flexShrink: 0 }} />
          <div
            style={{
              fontSize: 13,
              lineHeight: 1.2,
              minWidth: 0,
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
            }}
          >
            <strong>{lineCount}</strong> {lineCount === 1 ? t('item', 'item') : t('items', 'items')}
            <div style={{ opacity: 0.9 }}>
              <Price amount={cart?.grandTotal ?? cart?.subtotal ?? 0} color="#ffffff" />
            </div>
          </div>
        </div>
        <Link to="/cart" style={{ flexShrink: 0 }}>
          <Button shape="round" size="small">
            {t('Basket', 'Basket')} <ArrowRightOutlined />
          </Button>
        </Link>
      </div>
    );
  }

  return (
    <div className="default-mobile-cart-bar">
      <div className="default-mobile-cart-bar__meta">
        <ShoppingOutlined />
        <div>
          <strong>{lineCount}</strong> {lineCount === 1 ? t('item', 'item') : t('items', 'items')}
          <div>
            <Price amount={cart?.grandTotal ?? cart?.subtotal ?? 0} color="#fff" />
          </div>
        </div>
      </div>
      <Link to="/cart" style={{ flexShrink: 0 }}>
        <Button shape="round" size="small" className="default-mobile-cart-bar__cta">
          {t('Basket', 'Basket')} <ArrowRightOutlined />
        </Button>
      </Link>
    </div>
  );
}
